import { Alert } from '@uplift/ui';
import { useL10n } from '@uplift/hooks';
import { Box } from '@mui/material';


export const SuccessFailAlert = ({ isSubmitSuccess }) => {
  const l10n = useL10n();

  if (isSubmitSuccess === null) return null;
  return (
    <Box mb={4} mt={2.5}>
      {isSubmitSuccess === true && (
        <Alert
          color="success"
          title={l10n.support.submitSuccess.title}
          desc={l10n.support.submitSuccess.subtitle}
          withIcon={false}
          fullWidth
        />
      )}
      {isSubmitSuccess === false && (
        <Alert color="error" desc={l10n.support.submitFail.desc} fullWidth />
      )}
    </Box>
  );
};